<template>
  <div class="staff-filebackup">

    <c-table
      class="mt10"
      ref="table"
      :columns="columns"
      url="/filebackup/personal"
      :paging="false"
    >
      <el-form-item slot="content">
       <span class="c999">文件上传后，系统需要时间进行处理，请等待几分钟后再进行查看。文件一次不要超过200M。</span>
      </el-form-item>
      <template slot="operate">
          <el-upload
            class="upload-demo"
            action="/api/filebackup/upload"
            name="uploadfile"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-progress="uploadProgress"
            :on-success="uploadSuccess">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
      </template>
      <el-table-column slot="caozuo" label="操作" width="100" fixed="right">
        <template v-slot="{row}">
          <el-button
            type="text"
            @click="download(row)"
          >下载</el-button>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'

export default {
  name: 'staff-filebackup',
  mixins: [ mixin ],
  components: { CTable },
  data () {
    return {
      columns: [
        { prop: 'filename', label: '文件名' },
        { prop: 'size', label: '大小', width: 100, filter: val => val / 1048576 > 1 ? `${(val / 1048576).toFixed(1)}M` : val / 1024 > 1 ? `${(val / 1024).toFixed(1)}KB` : `${val}字节` },
        { slot: 'caozuo' }
      ],
      notify: {}
    }
  },
  methods: {
    download({ id, filename }) {
      this.$notify.success({
        title: '正在下载...',
        message: filename
      })
      this.$http.post(`/filebackup/get`, {
        fileid: id
      }, {
        responseType: 'blob'
      }).then(res => {
        let link = document.createElement('a')
        let evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', false, false)
        link.href = URL.createObjectURL(res.data)
        link.download = filename
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 200
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 200MB!')
      } else {
        this.notify[file.uid] = this.$notify.success({
          title: '提示',
          message: file.name + ' 正在上传中，进度0%',
          duration: 0,
          showClose: false
        })
      }
      return isLt2M
    },
    uploadProgress(e, file) {
      this._progress = e.percent + '%'
      this.notify[file.uid].message = `${file.name} 正在上传中，进度${parseInt(this._progress)}%`
    },
    uploadSuccess(response, file) {
      this.notify[file.uid].close()
      if (response.status === 'success') {
        this.$message.success('上传成功')
        this.$refs.table.reload()
      }
    }
  }
}
</script>

<style lang="scss">
</style>
